<template>
  <div>
    <RowCardItem id="serviceInfo" :hide-icon="true">
      <div slot="header" class="row">
        <div class="d-flex align-items-start flex-fill col-md-3 col-sm-6">
          <div class="icon-container">
            <em class="fas fa-address-book text-orange" />
          </div>
          <div class="d-flex flex-column">
            <span class="data-title">Nombre del Estudiante:</span>
            <span class="data-content">{{ item.studentName }}</span>
          </div>
        </div>
        <div class="d-flex align-items-start flex-fill col-md-3 col-sm-6">
          <div class="icon-container">
            <em class="fas fa-address-book text-orange" />
          </div>
          <div class="d-flex flex-column">
            <span class="data-title">SIE:</span>
            <span class="data-content">{{ item.studentSieId }}</span>
          </div>
        </div>
        <div class="d-flex align-items-start flex-fill col-md-3 col-sm-6">
          <div class="icon-container">
            <em class="fas fa-ballot-check text-orange" />
          </div>
          <div class="d-flex flex-column">
            <span class="data-title">Número Referido:</span>
            <span class="data-content">{{ item.referralNumber }}</span>
          </div>
        </div>
        <div class="d-flex align-items-start flex-fill col-md-3 col-sm-6">
          <div class="icon-container">
            <em class="fas fa-ballot-check text-orange" />
          </div>
          <div class="d-flex flex-column">
            <span class="data-title">Servicio:</span>
            <span class="data-content">{{ item.disciplineName }}</span>
          </div>
        </div>
      </div>
    </RowCardItem>
  </div>
</template>

<script>
import RowCardItem from '@/components/common/rowcard/RowCardItem';
export default {
  name: 'ServiceInfo',
  components: {
    RowCardItem,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        studentName: '',
        sie: '',
        referralNumber: '',
        service: '',
      }),
    },
  },
};
</script>

<style scoped lang="scss">
.icon-container {
  margin-top: 3px;
  margin-right: 12px;
  .far,
  .fas {
    font-size: 20px;
  }
}
.data-title {
  font-size: 16px;
}
</style>
